import React from "react";

const Loader = () => {
  return (
    <div style={styles.overlay}>
      <div className="spinner-border text-primary" style={styles.spinner} role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    backdropFilter: "blur(4px)",
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 2000, // Higher than modal (Bootstrap modal is 1055)
  },
  spinner: {
    width: "3rem",
    height: "3rem",
  },
};

export default Loader;
